import React, { useMemo, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import GeneralContext from 'providers/General/General.context';

type PreviewModeToggleNavigationProps = {
  className?: string;
};

const HIDE_ON_ROUTES = [
  'listing-options',
  'media-package',
  'checkout',
  'teaser-preview',
];

const PreviewModeToggleNavigation: React.FC<
  PreviewModeToggleNavigationProps
> = (props) => {
  const { className } = props;
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { isSafari } = useContext(GeneralContext);

  const isInPreviewMode = useMemo(
    () => pathname.includes('preview-mode'),
    [pathname],
  );

  const classes = classNames(
    'listing-creation-wizard__top-content',
    className,
    {
      isInPreviewMode,
      'is-safari': isSafari,
    },
  );

  const hideNavigation = useMemo(
    () => HIDE_ON_ROUTES.some((el) => pathname.includes(el)),
    [pathname],
  );

  if (hideNavigation) return null;

  return (
    <nav className={classes}>
      <div className="listing-creation-wizard__top-content__links">
        <Link className="preview-mode-link" to={`./default`} replace>
          {t('formView')}
        </Link>

        <Link className="preview-mode-link" to={`./preview-mode`} replace>
          {t('previewMode')}
        </Link>
      </div>
    </nav>
  );
};

export default PreviewModeToggleNavigation;
